import Axios from 'axios'

const alert = {
  sendAgreeTerms () {
    return Axios.patch(`/api/v1/employees/terms-and-policy/accepted`)
  },
  getTermsAndPolicy () {
    return Axios.get(`/api/v1/terms-and-policy`)
  },
  sendNPSFeedback (body) {
    return Axios.post(`/api/v1/employees/rating`, body)
  }
}

export default alert
